<!-- @Author: xiaodongyu -->
<!-- @Date: 2024-02-25 18:47:57 -->
<!-- @Last Modified by: xiaodongyu -->
<!-- @Last Modified time: 2024-02-29 17:38:33 -->

<template>
    <div class="nav-bar">
        <router-link :to="{name: 'Index'}">
            <h2 class="bold">
                Instacash
            </h2>
        </router-link>

        <div class="routes">
            <router-link :to="{name: 'Index'}">
                Home
            </router-link>
            <a-dropdown>
                <a>
                    ファンド一覧
                    <arrow-down />
                </a>
                <a-menu slot="overlay">
                    <a-menu-item>
                        <router-link :to="{name: 'ProductList'}">
                            ファンド一覧
                        </router-link>
                    </a-menu-item>
                    <a-menu-item>
                        <router-link :to="{name: 'ProductHold'}">
                            保有ファンド
                        </router-link>
                    </a-menu-item>
                    <a-menu-item>
                        <router-link :to="{name: 'TradeRecord'}">
                            取引履歴
                        </router-link>
                    </a-menu-item>
                </a-menu>
            </a-dropdown>
            <router-link :to="{name: 'AboutUs'}">
                会社概要
            </router-link>
        </div>

        <div class="user">
            <router-link
                v-if="finance.userEmail"
                class="b3 user-email"
                :to="{name: 'Profile'}"
            >
                {{ finance.userName || finance.userEmail }}
            </router-link>
            <button
                class="b3 bold"
                @click="onClick"
            >
                {{ btnText }}
            </button>
        </div>
    </div>
</template>

<script>
import {Dropdown, Menu} from 'ant-design-vue';
import Vue from 'vue';
import {mapState, mapMutations} from 'vuex';

import ArrowDown from './arrow-down.vc.svg';

[Dropdown, Menu].forEach(component => {
    Vue.use(component);
});

export default {
    name: 'NavBar',

    components: {
        ArrowDown
    },

    computed: {
        ...mapState(['finance']),

        btnText() {
            return this.finance.userEmail ? 'サインアウト' : '新規登録';
        }
    },

    methods: {
        ...mapMutations({
            commitLogout: 'finance/logout'
        }),

        onClick() {
            const {userEmail, currentStepRouteName} = this.finance;
            if (userEmail) {
                this.commitLogout();
                this.$router.push({name: 'Index'});
            } else {
                this.$router.push({name: currentStepRouteName || 'RegisterStep1-1'});
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.nav-bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    z-index: 10;
    padding: 0.22rem 1rem;
    height: 0.8rem;
    background-color: $c-08;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;

    h2 {
        color: $grey-03;
        cursor: pointer;
    }

    .routes {
        width: 3.2rem;
        display: flex;
        justify-content: space-between;

        a {
            color: $c-01;
            transition: all 0.3s;

            svg {
                transition: all 0.3s;
            }

            &:hover,
            &.router-link-exact-active {
                color: $yellow-02;

                svg {
                    transform: rotate(180deg);
                }
            }

            &.router-link-exact-active {
                font-weight: 700;
            }
        }
    }

    .user {
        display: flex;
        align-items: center;

        &-email {
            margin-right: 0.1rem;
            padding: 0.08rem 0;
            color: $c-02;
            cursor: pointer;
            text-decoration: underline;
        }

        button {
            padding: 0.08rem 0.2rem;
            background-color: $c-01;
            border-radius: 1rem;
            width: auto;
            height: auto;
        }
    }
}
</style>
